// extracted by mini-css-extract-plugin
export default {"message":"Message_message__p3Vgy","sucess":"Message_sucess__SuiuA","error":"Message_error__dl87C"};